// extracted by mini-css-extract-plugin
export default {"companyName":"portal_companyName__PVEOK","light":"portal_light__kMRFX","bodyContainer":"portal_bodyContainer__paTIJ"};